import { useLocalStorage } from "@vueuse/core";

export const addToSearchHistory = (
  storageId: string,
  searchValue: string,
  maxSearchHistoryLength: number = 12,
) => {
  const searchHistory = useLocalStorage<string[]>(storageId, []);
  // добавлять в историю необходимо в начало массива
  searchHistory.value.unshift(searchValue);
  // чистим от дублей
  if (searchHistory.value.includes(searchValue)) {
    searchHistory.value = Array.from(new Set(searchHistory.value));
  }
  // надо обрезать историю, если массив слишком большой
  if (searchHistory.value.length > maxSearchHistoryLength) {
    searchHistory.value.length = maxSearchHistoryLength;
  }
};

export const clearSearchHistory = (storageId: string) => {
  const searchHistory = useLocalStorage<string[]>(storageId, []);
  // при разлогине не забыть очищать LS
  searchHistory.value = [];
};
